import React from 'react';
import { SwatchLegendItem } from './components/subComponents';

const retailersNearSchoolsSubpanel = (
  <>
    Defined as within 1000' of a school
    <br />
    <SwatchLegendItem backgroundColor="#913fdf" borderColor="#000000" text="Retailer is near a school" />
    <SwatchLegendItem backgroundColor="#f28e36" borderColor="#000000" text="Retailer is not near a school" />
    <br />
    <em style={{ fontSize: '85%' }}>Note: This view is only available at close-up levels.</em>
  </>
);

// Retailer near retailers subpanel content
const retailersNearRetailersSubpanel = (
  <>
    Defined as within 500' of another retailer
    <br />
    <SwatchLegendItem backgroundColor="#913fdf" borderColor="#000000" text="Retailer is near another retailer" />
    <SwatchLegendItem backgroundColor="#f28e36" borderColor="#000000" text="Retailer is not near another retailer" />
    <SwatchLegendItem backgroundColor="#B8B8B8" borderColor="#000000" text="Out of business / Does not sell tobacco" />
    <br />
    <em style={{ fontSize: '85%' }}>Note: This view is only available at close-up levels.</em>
  </>
);

export const INSPECTION_RESULTS_FILTERS_NAMES = {
  all_current_retailers: 'all_current_retailers',
  current_retailers_never_inspected: 'current_retailers_never_inspected',
  current_retailers_failing_inspection: 'current_retailers_failing_inspection',
  retailers_failing: 'retailers_failing',
  retailers_passing: 'retailers_passing',
  inspection_failure_rate_by: 'inspection_failure_rate_by',
};

export const DEMOGRAPHICS_LIST_OBJ = [
  { id: 'pctblack', label: 'Black', image: '' },
  { id: 'pctamerind', label: 'Native American' },
  { id: 'pctashawpi', label: 'Asian or Pacific' },
  { id: 'pctwhite', label: 'White' },
  { id: 'pctotherrace', label: 'Other Race/Ethnicity' },
  { id: 'pcthisp', label: 'Hispanic' },
  { id: 'pctyouth', label: 'Youth' },
  { id: 'mhhinc', label: 'Income', isReversed: true },
  { id: 'popdens', label: 'Population Density' },
  { id: 'edattain', label: 'Educational Attainment', isReversed: true },
  {
    id: 'sovulnindex',
    label: 'Social Vulnerability Index',
    additionalText: 'This statistic is shown at County level regardless of the selection above.',
  },
  {
    id: 'lifeexpect',
    label: 'Life Expectancy',
    isReversed: true,
    additionalText: 'This statistic is shown at County level regardless of the selection above.',
  },
];

export const AGE_DEMOGRAPHICS = [
  { id: 'pctchild', label: 'Age 10-17' },
  { id: 'pctyoung', label: 'Age 18-24' },
];

export const REFERENCE_LAYERS_LIST_OBJ = [
  { id: 'venue-v2-publicschool', label: 'Public/Charter Schools', image: 'venue-publicschool' },
  { id: 'venue-v2-privateschool', label: 'Private Schools', image: 'venue-privateschool' },
  { id: 'venue-v2-park', label: 'Parks', image: 'venue-park' },
  { id: 'venue-v2-college', label: 'Colleges/Universities', image: 'venue-college' },
  { id: 'venue-v2-multihousing', label: 'Multi-Unit Housing', image: 'venue-multihousing' },
  { id: 'venue-v2-govbuilding', label: 'Government Buildings', image: 'venue-govbuilding' },
  { id: 'venue-v2-hospital', label: 'Hospitals/Clinics', image: 'venue-hospital' },
];

export const RETAILER_SECTION_OBJ = [
  {
    id: 'retailerpoints',
    label: 'Retailer Locations',
    stackingOrder: '300',
    swatchStyle: { backgroundColor: '#FF8080', borderColor: '#FF0000' },
  },
  {
    id: 'retailersnearretailers',
    label: 'Retailers Near Other Retailers',
    stackingOrder: '301',
    subpanel: retailersNearRetailersSubpanel,
  },
  {
    id: 'retailersnearschools',
    label: 'Retailers Near Youth',
    stackingOrder: '301',
    subpanel: retailersNearSchoolsSubpanel,
  },
];

export const MASS_ACCOUNT_MAP_SECTIONS = {
  retailers: false,
  otherbounds: false,
  reference: false,
  demographics: false,
  proximity: false,
};

export const REPORTS = {
  DOR: [
    {
      id: 'dor-inspection-agent',
      title: 'DOR Agent Activity Report',
      text: 'To generate a DOR Agent Activity Report, enter a desired date range and click "Download/Email".',
    },
    {
      id: 'dor-corporation-compliance',
      title: 'DOR Corporation Compliance Report',
      text: 'To generate a DOR Corporation Compliance Report, enter a desired date range and click "Download/Email".',
    },
    {
      id: 'dor-court-disposition',
      title: 'DOR Court Dispositions  Report',
      text: 'To generate a DOR Court Dispositions Report, enter a desired date range and click "Download/Email".',
    },
    {
      id: 'dor-licensed-distributor',
      title: 'DOR Inspections for Licensed Distributors Report',
      text: 'To generate a DOR Inspections Report, enter a desired date range and click "Download/Email".',
    },
    {
      id: 'dor-inspection-outcomes',
      title: 'DOR Inspection Outcome Report',
      text: 'To generate a DOR Inspection Outcome Report, enter a desired date range and click "Download/Email".',
    },
    {
      id: 'dor-inspection-results',
      title: 'DOR Inspection Results Overview Report',
      text: 'To generate a DOR Inspection Results Overview Report, enter a desired date range and click "Download/Email".',
    },
  ],
  AGO: [
    {
      id: 'ago-corporation-compliance',
      title: 'AGO Corporation Compliance Report',
      text: 'To generate an AGO Corporation Compliance Report, enter a desired date range and click "Download/Email".',
    },
    {
      id: 'ago-court-disposition',
      title: 'AGO Court Dispositions Report',
      text: 'To generate an AGO Court Dispositions Report, enter a desired date range and click "Download/Email".',
    },
    {
      id: 'ago-inspection-results-by-product-type',
      title: 'AGO  Inspection Results by Product Type Report',
      text: 'To generate an AGO Inspection Results by Product Type Report, enter a desired date range and click "Download/Email".',
    },
    {
      id: 'ago-inspection-results-by-store-type',
      title: 'AGO Inspection Results by Store Type Report',
      text: 'To generate an AGO Inspection Results by Store Type Report, enter a desired date range and click "Download/Email".',
    },
    {
      id: 'ago-inspection-results',
      title: 'AGO Inspection Results Overview Report',
      text: 'To generate an AGO Inspection Results Overview Report, enter a desired date range and click "Download/Email".',
    },
    {
      id: 'ago-youth-activity',
      title: 'AGO Youth Volunteer Activity Report',
      text: 'To generate an AGO Youth Volunteer Activity Report, enter a desired date range and click "Download/Email".',
    },
  ],
  FDA: [
    {
      id: 'fda-corporation-compliance',
      title: 'FDA Corporation Compliance Report',
      text: 'To generate an FDA Corporation Compliance Report, enter a desired date range and click "Download/Email".',
    },
    {
      id: 'fda-court-disposition',
      title: 'FDA Court Dispositions Report',
      text: 'To generate an FDA Court Dispositions Report, enter a desired date range and click "Download/Email".',
    },
    {
      id: 'fda-inspection-results',
      title: 'FDA Inspection Results Overview Report',
      text: 'To generate an FDA Inspection Results Overview Report, enter a desired date range and click "Download/Email".',
    },
  ],
  SYNAR: [
    {
      id: 'synar-inspection-report',
      title: 'Synar Inspection Report',
      text: 'To generate a Synar Inspection Report, select a year and click "Download/Email".',
    },
  ],
};

export const AZ_ACCOUNT_MAP_SECTIONS = {
  retailers: false,
  otherbounds: false,
  reference: false,
  demographics: false,
  mapFeatures: false,
  reports: false,
  inspectionResults: false,
  density: false,
  proximity: false,
  dorAgent: false,
  dorCorporation: false,
  dorCourt: false,
  dorInspections: false,
  dorOutcome: false,
  dorResults: false,
  agoCompliance: false,
  agoCourt: false,
  agoResultsByProduct: false,
  agoResultsByStore: false,
  agoResults: false,
  agoYouthActivity: false,
  fdaCorporation: false,
  fdaCourt: false,
  fdaResults: false,
  synarCorporation: false,
  synarResults: false,
};

export const AGENCIES_LIST = [
  { id: 'AGO', label: 'AGO', value: 'AGO', name: 'AGO', key: 'AGO' },
  { id: 'DOR', label: 'DOR', value: 'DOR', name: 'DOR', key: 'DOR' },
  { id: 'FDA', label: 'FDA', value: 'FDA', name: 'FDA', key: 'FDA' },
  { id: 'SYNAR', label: 'SYNAR', value: 'SYNAR', name: 'FDA', key: 'FDA' },
];

export const AGENCIES_LIST_NO_SYNAR = [
  { id: 'AGO', label: 'AGO', value: 'AGO', name: 'AGO', key: 'AGO' },
  { id: 'DOR', label: 'DOR', value: 'DOR', name: 'DOR', key: 'DOR' },
  { id: 'FDA', label: 'FDA', value: 'FDA', name: 'FDA', key: 'FDA' },
];

export const INSPECTION_AGENCIES_LIST = [
  { id: 1, label: ' - ', value: '', name: '-', key: '-' },
  { id: 2, label: 'AGO', value: 'AGO', name: 'AGO', key: 'AGO' },
  { id: 3, label: 'DOR', value: 'DOR', name: 'DOR', key: 'DOR' },
  { id: 4, label: 'FDA', value: 'FDA', name: 'FDA', key: 'FDA' },
  { id: 5, label: 'SYNAR', value: 'SYNAR', name: 'FDA', key: 'FDA' },
];

export const RANGE_LIST = [
  { id: '500 feet', label: '500 feet', value: '500', name: '500 feet', key: '500 feet' },
  { id: '1,000 feet', label: '1,000 feet', value: '1000', name: '1,000 feet', key: '1,000 feet' },
  { id: '1,500 feet', label: '1,500 feet', value: '1500', name: '1,500 feet', key: '1,500 feet' },
  { id: '2,000 feet', label: '2,000 feet', value: '2000', name: '2,000 feet', key: '2,000 feet' },
  { id: '1/2 mile', label: '1/2 mile', value: 'half_mile', name: '1/2 mile', key: '1/2 mile' },
  { id: '1 mile', label: '1 mile', value: 'mile', name: '1 mile', key: '1 mile' },
];

export const PROXIMITY_RANGE_LIST_OBJ = {
  retailersnearparksschools: {
    500: 'retailersnearparksschools_500ft',
    1000: 'retailersnearparksschools_1000ft',
    1500: 'retailersnearparksschools_1500ft',
    2000: 'retailersnearparksschools_2000ft',
    half_mile: 'retailersnearparksschools_half_mile',
    mile: 'retailersnearparksschools_mile',
  },
  retailersnearparksschools_or: {
    500: 'retailersnearparksschools_or_500ft',
    1000: 'retailersnearparksschools_or_1000ft',
    1500: 'retailersnearparksschools_or_1500ft',
    2000: 'retailersnearparksschools_or_2000ft',
    half_mile: 'retailersnearparksschools_or_half_mile',
    mile: 'retailersnearparksschools_or_mile',
  },
  near_school: {
    500: 'near_school_500ft',
    1000: 'near_school',
    1500: 'near_school_1500ft',
    2000: 'near_school_2000ft',
    half_mile: 'near_school_half_mile',
    mile: 'near_school_mile',
  },
  near_parks: {
    500: 'near_parks_500ft',
    1000: 'near_parks_1000ft',
    1500: 'near_parks_1500ft',
    2000: 'near_parks_2000ft',
    half_mile: 'near_parks_half_mile',
    mile: 'near_parks_mile',
  },
  near_retailer: {
    500: 'near_retailer',
    1000: 'near_retailer_1000',
    1500: 'near_retailer_1500',
    2000: 'near_retailer_2000',
    half_mile: 'near_retailer_half_mile',
    mile: 'near_retailer_mile',
  },
};

export const PLACE_LIST = [
  {
    id: 'Schools and Parks',
    label: 'Schools and Parks',
    value: 'retailersnearparksschools',
    name: 'Schools and Parks',
    key: 'Schools and Parks',
  },
  {
    id: 'Schools or Parks',
    label: 'Schools or Parks',
    value: 'retailersnearparksschools_or',
    name: 'Schools or Parks',
    key: 'Schools or Parks',
  },
  { id: 'Schools', label: 'Schools', value: 'near_school', name: 'Schools', key: 'Schools' },
  { id: 'Parks', label: 'Parks', value: 'near_parks', name: 'Parks', key: 'Parks' },
];

export const LOCATION_LIST = [
  {
    id: 'County',
    label: 'County',
    value: 'county',
    name: 'County',
    key: 'County',
  },
  {
    id: 'Zip Code',
    label: 'Zip Code',
    value: 'zipcode',
    name: 'Zip Code',
    key: 'Zip Code',
  },
  {
    id: 'Court District',
    label: 'Court District',
    value: 'courtdistrict',
    name: 'Court District',
    key: 'Court District',
  },
  { id: 'Census Tract', label: 'Census Tract', value: 'censustract', name: 'Census Tract', key: 'Census Tract' },
];

export const PROXIMITY_SECTION_OBJ = [
  {
    id: 'retailerpoints',
    label: 'Retailer Locations',
    stackingOrder: '300',
    inputType: 'checkbox-item',
    swatchStyle: { backgroundColor: '#FF8080', borderColor: '#FF0000', marginRight: '5px', marginTop: '2px' },
  },
  {
    id: 'retailersnearschools_az',
    label: 'Retailers within',
    stackingOrder: '301',
    inputType: 'radio-item',
    type: 'radio',
    subpanel: 'retailersNearSchoolsSubpanel',
  },
  {
    id: 'retailersnearretailers_az',
    label: 'Retailers within',
    stackingOrder: '301',
    inputType: 'radio-item',
    type: 'radio',
    subpanel: 'retailersNearRetailersSubpanel',
  },
  {
    id: 'no_proximity',
    label: 'Do not show proximity',
    stackingOrder: '301',
    inputType: 'radio-item',
    type: 'radio',
  },
];

export const DENSITY_SECTION_OBJ = [
  {
    id: 'retailerpoints',
    label: 'Retailer Locations',
    stackingOrder: '300',
    inputType: 'checkbox-item',
    type: 'checkbox',
    swatchStyle: { backgroundColor: '#FF8080', borderColor: '#FF0000', marginRight: '5px', marginTop: '2px' },
  },
  {
    id: 'retailers_density',
    label: 'Show density by',
    stackingOrder: '301',
    inputType: 'radio-item',
    type: 'radio',
    subpanel: 'showDensity',
  },
  {
    id: 'retailers_swamp',
    label: 'Show swamp by',
    stackingOrder: '301',
    inputType: 'radio-item',
    type: 'radio',
    subpanel: 'showSwamp',
  },
  {
    id: 'no_density',
    label: 'Do not show density/swamps',
    stackingOrder: '301',
    inputType: 'radio-item',
    type: 'radio',
  },
];

export const INSPECTION_RESULTS_DEMOGRAPHICS = [
  {
    id: 'inspection_failure_rate_by',
    label: 'Inspection failure rate by',
    stackingOrder: '301',
    inputType: 'radio-item',
    subpanel: 'inspectionFailure',
  },
];

export const INSPECTION_RESULTS_FILTERS = [
  {
    id: INSPECTION_RESULTS_FILTERS_NAMES.all_current_retailers,
    label: 'All current retailer locations',
    stackingOrder: '300',
    inputType: 'radio-item',
  },
  {
    id: INSPECTION_RESULTS_FILTERS_NAMES.current_retailers_never_inspected,
    label: 'Current retailers never inspected',
    stackingOrder: '301',
    inputType: 'radio-item',
  },
  {
    id: INSPECTION_RESULTS_FILTERS_NAMES.current_retailers_failing_inspection,
    label: 'Current retailers failing inspection',
    stackingOrder: '301',
    inputType: 'radio-item',
    subpanel: 'currentRetailersFailing',
  },
  {
    id: INSPECTION_RESULTS_FILTERS_NAMES.retailers_failing,
    label: 'Retailers failing',
    stackingOrder: '301',
    inputType: 'radio-item',
    subpanel: 'retailersFailingInspection',
  },
  {
    id: INSPECTION_RESULTS_FILTERS_NAMES.retailers_passing,
    label: 'Retailers passing inspection',
    stackingOrder: '301',
    inputType: 'radio-item',
    subpanel: 'retailersPassingInspection',
  },
  {
    id: INSPECTION_RESULTS_FILTERS_NAMES.inspection_failure_rate_by,
    label: 'Inspection failure',
    stackingOrder: '301',
    inputType: 'radio-item',
    subpanel: 'inspectionFailure',
  },
];

export const PROXIMITY_DISTANCE_IN_METERS = {
  near_school_500ft: 152.4,
  near_school: 304.8,
  near_school_1500ft: 457.2,
  near_school_2000ft: 609.6,
  near_school_half_mile: 804.67,
  near_school_mile: 1609.34,
  near_parks_500ft: 152.4,
  near_parks_1000ft: 304.8,
  near_parks_1500ft: 457.2,
  near_parks_2000ft: 609.6,
  near_parks_half_mile: 804.67,
  near_parks_mile: 1609.34,
  retailersnearparksschools_500ft: 152.4,
  retailersnearparksschools_1000ft: 304.8,
  retailersnearparksschools_1500ft: 457.2,
  retailersnearparksschools_2000ft: 609.6,
  retailersnearparksschools_half_mile: 804.67,
  retailersnearparksschools_mile: 1609.34,
  retailersnearparksschools_or_500ft: 152.4,
  retailersnearparksschools_or_1000ft: 304.8,
  retailersnearparksschools_or_1500ft: 457.2,
  retailersnearparksschools_or_2000ft: 609.6,
  retailersnearparksschools_or_half_mile: 804.67,
  retailersnearparksschools_or_mile: 1609.34,
};

export const RETAILER_FAILING_INSPECTIONS_OPTIONS = [
  { id: 1, label: '1', value: '1', name: '1', key: '1' },
  { id: 2, label: '2', value: '2', name: '2', key: '2' },
  { id: 3, label: '3', value: '3', name: '3', key: '3' },
  { id: 4, label: '4', value: '4', name: '4', key: '4' },
  { id: 5, label: '5', value: '5', name: '5', key: '5' },
  { id: 6, label: '6', value: '6', name: '6', key: '6' },
  { id: 7, label: '7', value: '7', name: '7', key: '7' },
  { id: 8, label: '8', value: '8', name: '8', key: '8' },
  { id: 9, label: '9', value: '9', name: '9', key: '9' },
];

export const isCensusTract = (polytype) => {
  if (!polytype || typeof polytype !== 'string') return false;
  return polytype.trim().toLowerCase().includes('tract');
};

export const getDemographicsForPolytype = (polytype) => {
  const isTracts = isCensusTract(polytype);

  if (isTracts) {
    // For census tract: replace Youth with age-specific options
    const baseList = DEMOGRAPHICS_LIST_OBJ.filter((item) => item.id !== 'pctyouth');
    const youthIndex = DEMOGRAPHICS_LIST_OBJ.findIndex((item) => item.id === 'pctyouth');

    // Insert age demographics at the same position where Youth was
    const result = [...baseList];
    result.splice(youthIndex, 0, ...AGE_DEMOGRAPHICS);

    return result;
  }

  // For all other boundary types: use original list
  return DEMOGRAPHICS_LIST_OBJ;
};

export const isDemographicValidForPolytype = (demographicId, polytype) => {
  const availableDemographics = getDemographicsForPolytype(polytype);
  return availableDemographics.some((demo) => demo.id === demographicId);
};
